/* eslint-disable @typescript-eslint/no-explicit-any */

import Page from '../../../components/PageWrapper';
import { useEffect, useMemo, useState } from 'react';
import { fetchInsurerFiles } from '../../../api/requests';
import GTable from '../../../components/elements/GTable';
import Button from '../../../components/form-control/Button';
import moment from 'moment';
import { BsDownload } from 'react-icons/bs';
import { capitalizeSentence, getFormattedDate } from '../../../utils/miscFunctions';
import { useQuery } from '@tanstack/react-query';

const InsurerFiles = (): JSX.Element => {
  const [files, setFiles] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [showPerPage, setShowPerPage] = useState<number>(100);


  const getFiles = async () => {

    try {
      const response = await fetchInsurerFiles()
      setFiles(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useQuery({
    queryKey: ['getFiles', files],
    queryFn: () => getFiles(),
  })

  const downloadDocument = (row: any) => {
    const docUrl = row.row.original.documentUrl;
    window.open(docUrl, '_blank');
  };

  const columns = useMemo(
    () => [
      {
        Header: 'M',
        columns: [
          {
            Header: 'Requested By',
            accessor: 'requestedBy',
            Cell: (row: any) => {
              return (
                <span>
                  {row.row.original.requestedBy.firstName} {row.row.original.requestedBy.lastName}
                </span>
              );
            }
          },
          {
            Header: 'Resource Type',
            accessor: 'resouceType',
            Cell: (row: any) => {
              return <span>{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'File Type',
            accessor: 'fileType',
            Cell: (row: any) => {
              return <span>{row.cell.value ?? '-'}</span>;
            }
          },
          {
            Header: 'Date From',
            accessor: 'dateFrom',
            Cell: (row: any) => {
              return <span>{row.cell.value ? getFormattedDate({ date: row.cell.value }) : '-'}</span>;
            }
          },
          {
            Header: 'Date To',
            accessor: 'dateTo',
            Cell: (row: any) => {
              return <span>{row.cell.value ? getFormattedDate({ date: row.cell.value }) : '-'}</span>;
            }
          },
          {
            Header: 'Date Created',
            accessor: 'createdOn',
            Cell: (row: any) => {
              return <span>{row.cell.value ? getFormattedDate({ date: row.cell.value }) : '-'}</span>;
            }
          },
          {
            Header: 'Action',
            accessor: 'documentUrl',
            Cell: (row: any) => {
              return (
                <>
                  {row.cell.value && (
                    <>
                      <Button
                        label="Download"
                        className="bg-primary-main rounded"
                        icon={<BsDownload className="mr-2" />}
                        onClick={() => downloadDocument(row)}
                      />
                    </>
                  )}
                </>
              );
            }
          }
        ]
      }
    ],
    []
  );

  const page = 'resource';

  return (
    <Page title={capitalizeSentence(page)}>
      <div className="bg-white w-full min-h-full p-5">
        <div className="flex justify-between">
          <div>
            <div className="">
              <h2 className="font-semibold text-3xl">{capitalizeSentence(page)}s</h2>
              <span className="text-sm text-slate-400">
                View a list of all {page}s and associated details.{' '}
              </span>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto  mt-4">
          <GTable
            columns={columns}
            data={files}
            classes="h-fit"
            showSearch={false}
            tableType={page}
            paginationData={undefined}
            showPerPage={showPerPage}
            onShowPerPageChange={(page: number) => setShowPerPage(page)}
            loading={loading}
          />
        </div>
        {/* )}
          </>
        )} */}
      </div>
    </Page>
  );
};

export default InsurerFiles;
